import { DatasetController, Chart, UpdateMode } from 'chart.js';
import { BACKGROUND_COLORS, BORDER_COLORS } from '../types';

export class PolylineController extends DatasetController {
    static id = 'polyline';

    static defaults = {
        dataElementType: 'polyline',
    };

    static overrides = {
        interaction: { mode: 'nearest', intersect: true },
        scales: { x: { display: false }, y: { display: false } }
    };

    constructor(chart: Chart, datasetIndex: number) {
        super(chart, datasetIndex);
    }

    getDataset() {
        const data = this.chart.data.datasets[this.index] as any;
        return {
            ...data,
            backgroundColor: data.backgroundColor || BACKGROUND_COLORS[this.index % BACKGROUND_COLORS.length],
            borderColor: data.borderColor || BORDER_COLORS[this.index % BORDER_COLORS.length],
        };
    }

    update(_mode: UpdateMode) {}
}
